

import React, { useState } from 'react'
import '../index.css'
import Logo from '../assets/logo.png'
import Accountimg from '../assets/account_icon.png'
import Active from '../assets/active.png'
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.js'
import { motion } from 'framer-motion';

const AdminHeader = () => {
       const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const {logout} = useAuth();

  function goToNextPage(){
    navigate('/dashboard')
  }

  function handleLogout() {
    logout();
  }
  return (
    <header>

        <nav className="homify-nav" id="nav-bar">
            <Link to='/admin'>
              <div className="admin-logo-container">
                <img className="logo" src={Logo} alt="Homify Logo" /> 
                <p className="dash-anchor" >ADMIN</p>
              </div>
            </Link>

                        <div className="hamburger" onClick={() => setIsOpen(!isOpen)}>
                          <motion.div
                            className="line"
                            animate={isOpen ? { rotate: 45, y: 7 } : { rotate: 0, y: 0 }}
                            transition={{ duration: 0.3 }}
                          />
                          <motion.div
                            className="line"
                            animate={isOpen ? { opacity: 0 } : { opacity: 1 }}
                            transition={{ duration: 0.3 }}
                          />
                          <motion.div
                            className="line"
                            animate={isOpen ? { rotate: -45, y: -7 } : { rotate: 0, y: 0 }}
                            transition={{ duration: 0.3 }}
                          />
                        </div>

      
           
              <ul className={isOpen ? 'second-nav show-nav' : 'second-nav'}>
                <Link to='/admin/users'>
                  <li className="reg"><p onClick={() => setIsOpen(!isOpen)}  className="dash-anchor" >Users</p></li>
                </Link> 
                <Link to='/admin/properties'>
                  <li className="reg"><p onClick={() => setIsOpen(!isOpen)}  className="dash-anchor" >Properties</p></li>
                </Link> 
                
                  <li  onClick={handleLogout} class="login dash-anchor">LOGOUT</li>
            
            </ul>
        </nav>  
    </header>
  )
}

export default AdminHeader;